@let legendTypeValue = legendType();

@if (legendTypeValue === 'radar-winter') {
  <div class="radar-legend-block">
    <table class="table table-sm table-hover">
      <tr>
        <td width="28%">
          {{ 'PRODUCT.RADAR.LEGEND.PRECTYPE.INTENSITY' | translate }} (mm)
        </td>
        <td align="center" width="12%">0,5</td>
        <td align="center" width="12%">2</td>
        <td align="center" width="12%">8</td>
        <td align="center" width="12%">35</td>
        <td align="center" width="12%">150</td>
        <td align="center" width="12%">>150</td>
      </tr>
      <tr>
        <td>{{ 'PRODUCT.RADAR.LEGEND.PRECTYPE.RAIN' | translate }}</td>
        <td bgcolor="#C9E4F8">&nbsp;</td>
        <td bgcolor="#81C0EF">&nbsp;</td>
        <td bgcolor="#399DE6">&nbsp;</td>
        <td bgcolor="#256493">&nbsp;</td>
        <td bgcolor="#102B3F">&nbsp;</td>
        <td bgcolor="#001420">&nbsp;</td>
      </tr>
      <tr>
        <td>{{ 'PRODUCT.RADAR.LEGEND.PRECTYPE.SNOWRAIN' | translate }}</td>
        <td bgcolor="#F3F3F3">&nbsp;</td>
        <td bgcolor="#E4E4E4">&nbsp;</td>
        <td bgcolor="#D5D5D5">&nbsp;</td>
        <td bgcolor="#888888">&nbsp;</td>
        <td bgcolor="#5A5A5A">&nbsp;</td>
        <td bgcolor="#3B3B3B">&nbsp;</td>
      </tr>
      <tr>
        <td>{{ 'PRODUCT.RADAR.LEGEND.PRECTYPE.SNOW' | translate }}</td>
        <td bgcolor="#FBCACA">&nbsp;</td>
        <td bgcolor="#F68383">&nbsp;</td>
        <td bgcolor="#F23D3D">&nbsp;</td>
        <td bgcolor="#9B2727">&nbsp;</td>
        <td bgcolor="#641C1C">&nbsp;</td>
        <td bgcolor="#421111">&nbsp;</td>
      </tr>
      <tr>
        <td>{{ 'PRODUCT.RADAR.LEGEND.PRECTYPE.ICERAIN' | translate }}</td>
        <td bgcolor="#F0C4DB">&nbsp;</td>
        <td bgcolor="#DD76AB">&nbsp;</td>
        <td bgcolor="#CB297B">&nbsp;</td>
        <td bgcolor="#821B4F">&nbsp;</td>
        <td bgcolor="#501232">&nbsp;</td>
        <td bgcolor="#380C22">&nbsp;</td>
      </tr>
      <tr>
        <td>{{ 'PRODUCT.RADAR.LEGEND.PRECTYPE.UNKNOWN' | translate }}</td>
        <td bgcolor="yellow">&nbsp;</td>
        <td>&nbsp;</td>
        <td>&nbsp;</td>
        <td>&nbsp;</td>
        <td>&nbsp;</td>
        <td></td>
      </tr>
    </table>
  </div>
}

@if (legendTypeValue === 'radar-summer') {
  <div class="radar-legend-block">
    <table class="table table-sm table-hover">
      <tr valign="middle">
        <td width="28%">
          {{ 'PRODUCT.RADAR.LEGEND.PRECTYPE.INTENSITY' | translate }} (mm)
        </td>
        <td align="center" width="12%">0,5</td>
        <td align="center" width="12%">2</td>
        <td align="center" width="12%">8</td>
        <td align="center" width="12%">35</td>
        <td align="center" width="12%">150</td>
        <td align="center" width="12%">>150</td>
      </tr>
      <tr>
        <td>{{ 'PRODUCT.RADAR.LEGEND.PRECTYPE.RAIN' | translate }}</td>
        <td bgcolor="#C9E4F8">&nbsp;</td>
        <td bgcolor="#81C0EF">&nbsp;</td>
        <td bgcolor="#399DE6">&nbsp;</td>
        <td bgcolor="#256493">&nbsp;</td>
        <td bgcolor="#102B3F">&nbsp;</td>
        <td bgcolor="#001420">&nbsp;</td>
      </tr>
      <tr>
        <td>{{ 'PRODUCT.RADAR.LEGEND.PRECTYPE.GRAUPEL' | translate }}</td>
        <td bgcolor="#F3F3F3">&nbsp;</td>
        <td bgcolor="#E4E4E4">&nbsp;</td>
        <td bgcolor="#D5D5D5">&nbsp;</td>
        <td bgcolor="#888888">&nbsp;</td>
        <td bgcolor="#5A5A5A">&nbsp;</td>
        <td bgcolor="#3B3B3B">&nbsp;</td>
      </tr>
      <tr>
        <td>{{ 'PRODUCT.RADAR.LEGEND.PRECTYPE.HAIL' | translate }}</td>
        <td bgcolor="#FBCACA">&nbsp;</td>
        <td bgcolor="#F68383">&nbsp;</td>
        <td bgcolor="#F23D3D">&nbsp;</td>
        <td bgcolor="#9B2727">&nbsp;</td>
        <td bgcolor="#641C1C">&nbsp;</td>
        <td bgcolor="#421111">&nbsp;</td>
      </tr>
      <tr>
        <td>{{ 'PRODUCT.RADAR.LEGEND.PRECTYPE.UNKNOWN' | translate }}</td>
        <td bgcolor="yellow">&nbsp;</td>
        <td>&nbsp;</td>
        <td>&nbsp;</td>
        <td>&nbsp;</td>
        <td>&nbsp;</td>
        <td></td>
      </tr>
    </table>
  </div>
}

@if (legendTypeValue === 'celltracking') {
  <div class="radar-legend-block">
    <h4>{{ 'PRODUCT.RADAR.LEGEND.TRACKING.PROBABILITY' | translate }} (%)</h4>
    <small>
      <table [ngStyle]="{ width: '100%' }" class="table table-sm table-hover">
        <tr>
          <td style="text-align: center; width: 10%">10</td>
          <td style="text-align: center; width: 10%">20</td>
          <td style="text-align: center; width: 10%">30</td>
          <td style="text-align: center; width: 10%">40</td>
          <td style="text-align: center; width: 10%">50</td>
          <td style="text-align: center; width: 10%">60</td>
          <td style="text-align: center; width: 10%">70</td>
          <td style="text-align: center; width: 10%">80</td>
          <td style="text-align: center; width: 10%">90</td>
        </tr>
        <tr>
          <td height="2px" bgcolor="#f7f9be"></td>
          <td height="5px" bgcolor="#f2e3a2"></td>
          <td height="5px" bgcolor="#fbdb8d"></td>
          <td height="5px" bgcolor="#fac87f"></td>
          <td height="5px" bgcolor="#f4b36f"></td>
          <td height="5px" bgcolor="#f39d67"></td>
          <td height="5px" bgcolor="#f48463"></td>
          <td height="5px" bgcolor="#e96b59"></td>
          <td height="5px" bgcolor="#b54344"></td>
        </tr>
      </table>
    </small>
  </div>
}

@if (
  radarService.showDistanceLegend() && legendTypeValue == 'circle-distance'
) {
  <div class="radar-legend-block">
    <h4>{{ 'PRODUCT.RADAR.LEGEND.DISTANCE' | translate }} (km)</h4>
    <div
      class="distance-legend-container"
      style="display: inline-flex; align-items: center; padding: 5px">
      <svg width="100" height="100" viewBox="0 0 100 100">
        <circle
          cx="50"
          cy="50"
          r="45"
          fill="none"
          stroke="gray"
          stroke-width="1" />
        <circle
          cx="50"
          cy="50"
          r="30"
          fill="none"
          stroke="gray"
          stroke-width="1" />
        <circle
          cx="50"
          cy="50"
          r="15"
          fill="none"
          stroke="gray"
          stroke-width="1" />
        <g
          fill="gray"
          font-size="10"
          font-family="sans-serif"
          text-anchor="middle">
          <text x="50" y="52">15km</text>
          <text x="50" y="33">75km</text>
          <text x="50" y="17">150km</text>
        </g>
      </svg>
    </div>
  </div>
}
